import React from "react"
import Header from "../components/header"
import Footer from "../components/footer"
import PageTransition from "gatsby-v2-plugin-page-transitions"
import { Helmet } from "react-helmet"
import { isMobile } from "react-device-detect"

export default function Info() {
  return (
    <PageTransition
      transitionStyles={{
        entering: { opacity: 0 },
        entered: { opacity: 1 },
        exiting: { opacity: 1 },
        exited: { opacity: 0 },
      }}
    >
      <div className="wrapper">
        <Helmet>
          <meta charSet="utf-8" />
          <title>Info - Governors Point</title>
          <meta
            name="description"
            content="Please email us if you have any questions or would like further information about Governors Point."
          />
          <link rel="canonical" href="https://governorspoint.com" />
          <body className={isMobile ? `dark mobile` : `dark`} />
        </Helmet>

        <Header menuActive="" />

        <div className="main">
          <div className="container-inner">
            <div className="image-copy-width press-section">
              <p className="fill-space"></p>
              <p className="mt-60">Press & Publications</p>
              <ul className="no-list-style">
                <li className="press-feature">
                  <h3>Architectural Digest</h3>
                  <div className="caption">October 2024</div>
                  <p>
                    "Designed by Omer Arbel, the residences are located on one
                    of the last private coastal plots in Washington State."
                  </p>
                  <a
                    href="https://www.architecturaldigest.com/story/at-governors-point-16-remote-homes-blend-into-nature-like-weve-never-seen-before"
                    rel="noreferrer"
                    target="_blank"
                  >
                    At Governors Point, 16 Remote Homes Blend Into Nature Like
                    We’ve Never Seen Before
                  </a>
                </li>
                <li className="press-feature">
                  <h3>The Architect's Newspaper</h3>
                  <div className="caption">April 2026</div>
                  <p>
                    "Under the planted roof, the space is something like a
                    spider's lair or a grotto; black-concrete walls are
                    punctuated with hollows of varying sizes that bubble across
                    the project like the pocked faces of nearby bluffs."
                  </p>
                  <a
                    href="https://www.archpaper.com/2026/04/bocci-omer-arbel-spatial-experiences/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    At Bocci and beyond, Omer Arbel conjures magical spatial
                    experiences
                  </a>
                </li>
                <li className="press-feature">
                  <h3>Dezeen</h3>
                  <div className="caption">October 2024</div>
                  <p>
                    "The houses are organized as a set of sectional
                    relationships encouraging cinematic awareness of other
                    occupants in the home."
                  </p>
                  <a
                    href="https://www.dezeen.com/2024/10/29/omer-arbel-washington-houses-cedar-orb-clouds/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Omer Arbel proposes surrounding Washington houses with
                    'cedar orb clouds'
                  </a>
                </li>
                <li className="press-feature">
                  <h3>Surface</h3>
                  <div className="caption">October 2024</div>
                  <p>
                    "The potential here is for the architecture and ecology of
                    the sites on Governor's Point to become one and the same."
                  </p>
                  <a
                    href="https://www.surfacemag.com/articles/governors-point-houses-omer-arbel/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    At Governors Point, Omer Arbel Meets the Sea Ranch
                  </a>
                </li>
              </ul>
            </div>
            <div className="image-copy-width">
              <p>
                <a href="mailto:info@governorspoint.org">
                  info@governorspoint.org
                </a>
              </p>
              <p className="mt-60">Additional details</p>
              <ul className="no-list-style">
                <li>
                  <a
                    href="/files/Project Overview.pdf"
                    rel="noreferrer"
                    target="_blank"
                    className="download"
                  >
                    Project Overview PDF
                  </a>
                </li>
                <li>
                  <a
                    href="/files/Nature Reserve & Trail Map.pdf"
                    rel="noreferrer"
                    target="_blank"
                    className="download"
                  >
                    Nature Reserve & Trail Map
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/watch?v=qvCiBxunH8Y&t=6s"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Whatcom Land Trust Video
                  </a>
                </li>
                <li>
                  <a
                    href="/files/Preliminary Plat Map.pdf"
                    rel="noreferrer"
                    target="_blank"
                    className="download"
                  >
                    Preliminary Plat Map
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.adventuresnw.com/governors-point-finding-harmony-on-the-chuckanut-coast/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Local Article on the project
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.seattletimes.com/life/travel/a-food-loverrsquos-tour-of-washingtonrsquos-chuckanut-drive/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Seattle Times on the Area
                  </a>
                </li>
                <li>
                  <a
                    href="https://omerarbel.com/projects/aedes/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Architecture Exhibition
                  </a>
                </li>
                <li>
                  <a
                    href="https://goo.gl/maps/BH5BQN81wJfRZWEA8"
                    rel="noreferrer"
                    target="_blank"
                  >
                    Location
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </PageTransition>
  )
}
